<template>
  <div>
    <div
      v-if="!NavSolid"
      :class="NavSolid ? ' ' : 'menu-area-body'"
      style="height: 5rem"
    ></div>

    <div class="bg-light">
      <div class="container-custom">
        <div class="row py-5">
          <div class="col-lg-3 col-md-4 col-12 sticky-div mt-3" :style="isDesktop ? 'height: 95vh; top: 1rem' : ''">
            <div class="card shadow p-4 rounded" :class="isDesktop ? '' : (showFilters ? '' : 'd-none')">
              <filterHome botonTransparent="btn-light-primary" clase="form-control"></filterHome>
            </div>
          </div>
          <div class="col-lg-9 col-md-8 col-12">
            <div class="d-flex flex-column flex-md-row">
              <div>
                <h2>{{ $t('agents.profileHeading') }}</h2>
              </div>

              <div class="btn-toolbar-actions ml-md-auto d-flex align-items-center gap-2 mt-3 mt-md-0">
                <div class="btn-group-toggle-group align-items-center bg-card rounded shadow-sm p-1 d-none d-lg-flex">
                  <button
                    :class="showButton == true ? 'btn-active-primary' : 'btn-inactive'"
                    @click="showButton = true"
                    class="btn-toggle btn btn-sm"
                    :title="$t('properties.gridView')"
                  >
                    <i class="fa-solid fa-grip-vertical"></i>
                  </button>
                  <button
                    :class="showButton != true ? 'btn-active-primary' : 'btn-inactive'"
                    @click="showButton = false"
                    class="btn-toggle btn btn-sm"
                    :title="$t('properties.listView')"
                  >
                    <i class="fa-solid fa-list"></i>
                  </button>
                </div>

                <button class="btn btn-light-primary mr-auto btn-pill d-lg-none" @click="showFilters = !showFilters">
                  <i class="fas fa-sliders mr-1"></i> {{ $t('common.filter') }}
                </button>
              </div>
            </div>
            <hr />

            <div class="d-none d-sm-block">
              <div class="row ml-auto mr-auto bg-white border imgProfileAgent">
                <div class="col-md-5 pl-0 ml-0 mx-0 bg-icon-danger">
                  <div v-if="isLoadingImages" class="image-loader">
                    <div class="spinner"></div>
                  </div>
                  <img
                    v-if="items.img_url != null"
                    class="img-card pr-2"
                    :src="items.img_url"
                    alt="Carousel Image"
                    @load="isLoadingImages = false"
                  />
                  <div v-if="!items.img_url" class="no-image">
                    <div class="circle bg-icon-danger big">
                      <i class="fa-solid fa-user danger"></i>
                    </div>
                  </div>
                  <!-- <img v-else class="img-card" src="https://salonlfc.com/wp-content/uploads/2018/01/image-not-found-scaled.png" alt="Carousel Image" /> -->
                </div>
                <div
                  class="col-md bg-card"
                  style="display: grid; height: 17rem !important"
                >
                  <div
                    class="pb-4"
                    style="margin-top: auto; margin-bottom: auto !important"
                  >
                    <div class="mb-3">
                      <a
                        v-if="items.Facebook_url"
                        class="text-white"
                        :href="items.Facebook_url"
                        target="_blank"
                      >
                        <button
                          class="btn-redes bg-facebook text-white mr-2"
                          style=""
                        >
                          <i class="fab fa-facebook"></i>
                        </button>
                      </a>
                      <a
                        v-if="items.Twitter_url"
                        class="text-white"
                        :href="items.Twitter_url"
                        target="_blank"
                      >
                        <button class="btn-redes bg-x text-white mr-2" style="">
                          <i class="fab fa-x-twitter"></i>
                        </button>
                      </a>
                      <a
                        v-if="items.Twitter_url"
                        class="text-white"
                        :href="items.LinkedIn_url"
                        target="_blank"
                      >
                        <button
                          class="btn-redes bg-linkedin text-white mr-2"
                          style=""
                        >
                          <i class="fa fa-linkedin"></i>
                        </button>
                      </a>
                    </div>
                    <div class="mr-auto">
                      <h4
                        class="font-weight-normal pb-0 mb-0 text-black"
                        style="white-space: normal !important"
                      >
                        {{ agenteNombre }}
                      </h4>
                      <span class="font-weight-black">Asesor Inmobiliario</span>
                    </div>

                    <div
                      style="width: 100%"
                      class="pt-2 text-black altura-card-footer-propiedades"
                    >
                      <div class="text-secondary">
                        <div
                          v-if="items.Celular"
                          class="pr-2 px-0 d-flex justify-content-start py-1"
                        >
                          <i class="fa-solid pt-1 fa-phone mr-1"></i>
                          <span>{{ formatPhoneNumber(items.Celular) }} </span>
                        </div>
                        <div
                          v-if="items.Email"
                          class="pr-2 px-0 d-flex justify-content-start py-1"
                        >
                          <i class="fa-regular pt-1 fa-envelope mr-1"></i>
                          <span>{{ items.Email }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="d-md-none">
              <div class="bg-white border">
                <div class="pl-0 ml-0 mx-0 bg-icon-danger imgProfileAgentSmall">
                  <img
                    v-if="items.img_url != null"
                    class="img-card pr-2"
                    :src="items.img_url"
                    alt="Carousel Image"
                  />
                  <div v-if="!items.img_url" class="no-image">
                    <div class="circle bg-icon-danger big">
                      <i class="fa-solid fa-user danger"></i>
                    </div>
                  </div>
                  <!-- <img v-else class="img-card" src="https://salonlfc.com/wp-content/uploads/2018/01/image-not-found-scaled.png" alt="Carousel Image" /> -->
                </div>
                <div class="bg-card p-3">
                  <div
                    class="pb-4"
                    style="margin-top: auto; margin-bottom: auto !important"
                  >
                    <div class="mb-3">
                      <a
                        v-if="items.Facebook_url"
                        class="text-white"
                        :href="items.Facebook_url"
                        target="_blank"
                      >
                        <button
                          class="btn-redes bg-facebook text-white mr-2"
                          style=""
                        >
                          <i class="fab fa-facebook"></i>
                        </button>
                      </a>
                      <a
                        v-if="items.Twitter_url"
                        class="text-white"
                        :href="items.Twitter_url"
                        target="_blank"
                      >
                        <button class="btn-redes bg-x text-white mr-2" style="">
                          <i class="fab fa-x-twitter"></i>
                        </button>
                      </a>
                      <a
                        v-if="items.Twitter_url"
                        class="text-white"
                        :href="items.LinkedIn_url"
                        target="_blank"
                      >
                        <button
                          class="btn-redes bg-linkedin text-white mr-2"
                          style=""
                        >
                          <i class="fa fa-linkedin"></i>
                        </button>
                      </a>
                    </div>
                    <div class="mr-auto">
                      <h4
                        class="font-weight-normal pb-0 mb-0 text-black"
                        style="white-space: normal !important"
                      >
                        {{ agenteNombre }}
                      </h4>
                      <span class="font-weight-black">Asesor Inmobiliario</span>
                    </div>

                    <div
                      style="width: 100%"
                      class="pt-2 text-black altura-card-footer-propiedades"
                    >
                      <div class="text-secondary">
                        <div
                          class="pr-2 px-0 d-flex justify-content-start py-1"
                        >
                          <i class="fa-solid pt-1 fa-phone mr-1"></i>
                          <span>{{ formatPhoneNumber(items.Celular) }} </span>
                        </div>
                        <div
                          class="pr-2 px-0 d-flex justify-content-start py-1"
                        >
                          <i class="fa-regular pt-1 fa-envelope mr-1"></i>
                          <span>{{ items.Email }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="my-3 p-4 bg-white border rounded">
              <h3 class="pb-2">{{ $t('agents.aboutAgent') }}</h3>
              <p class="text-secondary">{{ agenteDescripcion }}</p>
              <!-- {{ items.Propiedades }} -->
            </div>
            <div v-if="items.Propiedades && items.Propiedades.length > 0" class="mt-5 px-sm-3">
              <div class="d-flex">
                <div>
                  <h2>{{ $t('properties.defaultHeading') }}</h2>
                  <div>
                    <p class="text-secondary">
                      {{ $t('agents.propertiesOf', { shown: items.Propiedades.length, total: items.Propiedades.length }) }}
                    </p>
                  </div>
                </div>

                <div
                  class="btn-toolbar-actions ml-auto d-flex align-items-center gap-2"
                >
                  <div
                    class="btn-group-toggle-group d-flex align-items-center bg-card rounded shadow-sm p-1"
                  >
                    <button
                      :class="
                        showButton == true
                          ? 'btn-active-primary'
                          : 'btn-inactive'
                      "
                      @click="showButton = true"
                      class="btn-toggle btn btn-sm d-none d-sm-block"
                      :title="$t('properties.gridView')"
                    >
                      <i class="fa-solid fa-grip-vertical"></i>
                    </button>
                    <button
                      :class="
                        showButton != true
                          ? 'btn-active-primary'
                          : 'btn-inactive'
                      "
                      @click="showButton = false"
                      class="btn-toggle btn btn-sm d-none d-sm-block"
                      :title="$t('properties.listView')"
                    >
                      <i class="fa-solid fa-list"></i>
                    </button>
                  </div>
                  <!-- <button style="border-radius: 3px !important;" :class="(showButton == true ? 'text-primary border border-primary' : 'border border-secondary text-secondary')" @click="showButton = true" class="btn-column btn btn-sm   ml-2 d-none d-sm-block"><i class="fa-solid fa-grip-vertical"></i></button>
              <button style="border-radius: 3px !important;" :class="(showButton != true ? 'text-primary border border-primary' : 'border border-secondary text-secondary')" @click="showButton = false" class="btn-column btn btn-sm   ml-2  d-none d-sm-block"><i class="fa-solid fa-list"></i></button>
              <button v-b-toggle.sidebar-no-header style="height: 3rem; width: 3rem;" class="btn btn-sm btn-light-primary ml-2 d-lg-none"><i class="fa-solid fa-bars pr-lg-3  "></i><span class="d-none d-lg-block">Filtro</span></button> -->
                </div>
              </div>
              <hr />

              <div class="d-none d-sm-block">
                <div v-if="showButton == true" class="row ml-auto mr-auto">
                  <div
                    class="col-6 mx-0"
                    v-for="el of items.Propiedades"
                    :key="el.id"
                  >
                    <product-vue :auto-slide="false" :product="el" />
                  </div>
                </div>
                <div v-else class="">
                  <div class="row ml-auto mr-auto">
                    <div
                      class="col-12 mx-0"
                      v-for="el of items.Propiedades"
                      :key="el.id"
                    >
                      <ProductPropertiesLarge
                        :product="el"
                        :detail="false"
                        class="bg-card rounded shadow"
                        :auto-slide="false"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="d-md-none px-0">
                <div class="row ml-auto mr-auto">
                  <div
                    class="col-12 mx-0"
                    v-for="el of items.Propiedades"
                    :key="el.id"
                  >
                    <product-vue
                      class="px-0"
                      :product="el"
                      :auto-slide="false"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProductPropertiesLarge from "../components/ProductPropertiesLarge.vue";
import ProductVue from "../components/ProductProperties.vue";

import ContactInfo from "../components/ContactInfo.vue";
import filterHome from "../components/filterHome.vue";
// import ImgSingleProperty from "../components/ImgSingleProperty.vue";
// import carousel from "../components/carousel.vue";
import CardAgent from "../components/CardAgent.vue";
import CardAgentLarge from "../components/CardAgentLarge.vue";
// import CardImg from "../components/Card-img.vue";

import contact from "../components/Contact.vue";
import { resolveStoredPublicDomain } from "@/utils/publicDomainStorage";
import { applySeo, markPrerenderPending, markPrerenderReady } from "@/utils/seo";
import { tFieldOrValue } from "@/i18n";

export default {
  props: ["NavSolid"],
  components: {
    ProductVue,
    CardAgent,
    contact,
    CardAgentLarge,
    filterHome,
    ContactInfo,
    ProductPropertiesLarge,
  },
  data() {
    return {
      id: "",
      table: "Agente",
      descripcionAgente:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
      items: {},
      showButton: false,
      showFilters: false,
      isDesktop: true,
      itemAgents: [
        {
          id: 1,
          cargo: "Real estate Agent",
          nombre: "Zack",
          apellido: "Lee",
          descripcion:
            "Real estate is divided into several categories, including residential property, commercial property and industrial property.commercial property and industrial property.",
          telefono: "+91 5470087201",
          correo: "life@gmail.in",
          medida: 4500,
          // precio: "$4513.00",
          fecha: "April 6, 2023",
        },
      ],
      images: ["https://sheltos-vue.vercel.app/image/avatar/5.jpg"],
      propiedadesCantidad: "5 propiedades",
      currentImage: 0,
      isLoadingImages: true,
    };
  },
  async mounted() {
    this.checkDesktop();
    window.addEventListener('resize', this.checkDesktop);
    
    this.$isLoading(true);
    this.id = this.$route.params.id;
    await this.getData();
    this.$isLoading(false);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkDesktop);
  },
  watch: {
    'items.img_url': {
      handler(newVal) {
        if (newVal) {
          this.preloadImage();
        } else {
          this.isLoadingImages = false;
        }
      },
      immediate: true
    }
  },
  computed: {
    // Locale reactivo
    currentLocale() {
      return this.$i18n.locale;
    },
    // Resolucion bilingue del nombre del agente (con fallback al campo plano)
    agenteNombre() {
      return tFieldOrValue(this.items || {}, "Nombre", this.currentLocale);
    },
    // Resolucion bilingue de la descripcion del agente
    agenteDescripcion() {
      return tFieldOrValue(this.items || {}, "Descripcion", this.currentLocale);
    },
  },
  methods: {
    checkDesktop() {
      this.isDesktop = window.innerWidth >= 992;
      if (this.isDesktop) this.showFilters = true;
    },
    preloadImage() {
      if (!this.items.img_url) {
        this.isLoadingImages = false;
        return;
      }
      this.isLoadingImages = true;
      const img = new Image();
      img.onload = () => {
        this.isLoadingImages = false;
      };
      img.onerror = () => {
        this.isLoadingImages = false;
      };
      img.src = this.items.img_url;
    },
    formatPhoneNumber(phone) {
      if (!phone) return "";

      const digits = phone.toString().replace(/\D/g, "");

      const countryCode = digits.slice(0, 3); // 505
      const localNumber = digits.slice(3); // 55047184

      const formattedLocal =
        localNumber.match(/.{1,4}/g)?.join(" ") || localNumber;

      return `+${countryCode} ${formattedLocal}`;
    },
    async getData() {
      markPrerenderPending();
      try {
        const domain = encodeURIComponent(resolveStoredPublicDomain(this.$domain));
        let res = await this.$store.dispatch("get", {
          path: `${this.table}/public/get/${this.id}?domain=${domain}`,
        });
        console.log("ln-280-----", res);
        this.items = res;
        applySeo(this.items.seo);
      } catch (error) {
        this.items = {};
        markPrerenderReady();
      }
      // try {
      //   let res = await this.$store.dispatch("get", { path: this.table + '/getAll/' + this.id });
      //   if(res.length>0){

      //     this.item = res
      //     console.log('ln-134 --->',this.items)
      //   }
      //   else{
      //     this.items = []
      //   }
      // } catch (error) {
      //   this.items = []
      //   alert(error);
      // }
    },

    // async getData() {
    //   try {
    //     let res = await this.$store.dispatch("get", { path: this.table + '/getAllByCategory/' + this.categoria_id});
    //     if(res.length>0){
    //       for await(let it of res[0].subcategorias){
    //         console.log(it)
    //         for await(let ele of it.tarjetas){
    //           //console.log(ele)
    //           // ele.ruta = '/detalle/'+ this.rutaCategoria + '/' + ele.id
    //           ele.ruta = ele.documento_descargable_tar!=null && ele.documento_descargable_tar!= '' ? ele.documento_descargable_tar : '/detalle/'+ this.rutaCategoria + '/' + ele.id

    //         }
    //       }
    //       this.items = res
    //       console.log('********--->',this.items)
    //     }
    //     else{
    //       this.items = []
    //     }
    //   } catch (error) {
    //     this.items = []
    //     alert(error);
    //   }
    // },
  },
};
</script>
<style scoped>
.imgProfileAgentSmall {
  height: 17rem !important; /* Altura fija del contenedor */
  border-radius: 1rem; /* Bordes redondeados */
  overflow: hidden; /* Recorta cualquier exceso de la imagen */
  position: relative; /* Posiciona el contenido relativo al contenedor */
}

.imgProfileAgentSmall img {
  position: absolute; /* La imagen se ajusta dentro del contenedor */
  top: 50%; /* Centra la imagen verticalmente */
  left: 50%; /* Centra la imagen horizontalmente */
  transform: translate(-50%, -50%); /* Garantiza un centrado perfecto */
  width: 27rem; /* Deja que la imagen mantenga su proporción natural */
  /* margin-right: auto !important; */
  height: 100%; /* Hace que la altura de la imagen llene el contenedor */
  object-fit: cover; /* Evita la deformación y ajusta la imagen al espacio */
}

.badge-container {
  position: absolute;
  top: 10px;
  left: 10px;
}
.imgProfileAgent {
  height: 17rem !important; /* Altura fija del contenedor */
  border-radius: 1rem; /* Bordes redondeados */
  overflow: hidden; /* Recorta cualquier exceso de la imagen */
  position: relative; /* Posiciona el contenido relativo al contenedor */
}

.imgProfileAgent img {
  position: absolute; /* La imagen se ajusta dentro del contenedor */
  top: 50%; /* Centra la imagen verticalmente */
  left: 50%; /* Centra la imagen horizontalmente */
  transform: translate(-50%, -50%); /* Garantiza un centrado perfecto */
  width: 27rem; /* Deja que la imagen mantenga su proporción natural */
  /* margin-right: auto !important; */
  height: 100%; /* Hace que la altura de la imagen llene el contenedor */
  object-fit: cover; /* Evita la deformación y ajusta la imagen al espacio */
}
.footer-section .map-container iframe {
  border-radius: 5px;
}
.tab-menu {
  display: flex;
  padding: 0;
  margin: 0;
  list-style-type: none;
  background-color: var(--bg-card);
  border-bottom: 1px solid #ddd;
}
.tab-menu li {
  margin-right: 20px;
  padding: 10px 15px;
  cursor: pointer;
  color: #555;
  font-weight: bold;
}
.tab-menu li.active {
  color: var(--primary);
  border-bottom: 2px solid var(--primary);
}

.details {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
}
.details div {
  width: 45%;
  margin-bottom: 10px;
  font-size: 14px;
  color: #555;
}
.details div strong {
  color: #333;
}
.property-brief {
  margin-top: 20px;
  color: #555;
  font-size: 14px;
  line-height: 1.6;
}
.attachments {
  margin-top: 20px;
  font-size: 14px;
}
.attachments a {
  text-decoration: none;
  color: var(--primary);
  font-weight: bold;
}
.attachments i {
  margin-right: 5px;
}
.map-link {
  float: right;
  color: var(--primary);
  font-size: 14px;
  cursor: pointer;
  text-decoration: none;
}
.containerV {
  display: flex;
  flex-direction: column; /* Organiza en columna */
  justify-content: center; /* Centra verticalmente */
  align-items: center; /* Centra horizontalmente */
  /*gap: 10px; /* Espacio entre el texto y los botones */
  /* Altura total */
  /* border: 1px solid #ddd; */
}
/* width */
::-webkit-scrollbar {
  width: 10px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #fdfcfc;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #e9e9e9;
  border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #e9e9e9;
}
.inner {
  max-width: 100%;
  margin: auto;
  padding-left: 15px;
  padding-right: 15px;
}
.scroll-container {
  position: relative;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
  width: 100%;

  scroll-snap-type: mandatory;
  scroll-behavior: smooth;

  word-wrap: break-word !important;
  margin-bottom: 50px;
}

.scroll-container .scroll-section {
  display: inline-block;
  vertical-align: middle;

  /* white-space: nowrap; */
}
/*Slider X (different sized images)*/

.scroll-container.diff-size {
  scroll-snap-destination: 50% 0%;
  padding: 20px 0px;
  margin: 1%;
}

.scroll-container.diff-size .scroll-section {
  width: auto;
  height: 100%;
  margin-right: 15px;
  scroll-snap-coordinate: 50% 0%;
}

.scroll-container.diff-size .scroll-section:first-child {
  scroll-snap-coordinate: 0% 0%, 50% 0%;
  margin-left: 15px;
}

.scroll-container.diff-size .scroll-section:last-child {
  scroll-snap-coordinate: 50% 0%, 100% 0%;
}

.searchdiv {
  /* background-color:#fd306e !important; */
  /* background-color: black !important; */
  /* padding: 30px;
  box-shadow: 0px 0px 10px 2px rgba(0, 0, 0, 0.25);
  border-radius: 20px; */
}
.buttonsearch {
  background-color: #fd306e !important;
  color: white;
}
.inputSearch {
  border-color: #fd306e !important;
}

.carousel-item img {
  /* height:100vh!important ; */
}
@media (max-width: 576px) {
  /* Estilos para pantallas pequeñas */
}

.image-loader {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--primary-dark);
  z-index: 5;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 4px solid rgba(255, 255, 255, 0.3);
  border-top-color: var(--primary);
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

@media (max-width: 991px) {
  .sticky-div {
    position: relative !important;
    height: auto !important;
    max-height: none !important;
  }
}

@media (max-width: 767px) {
  .btn-toolbar-actions {
    flex-wrap: nowrap;
    gap: 0.4rem !important;
    margin-top: 1rem;
    width: 100%;
    justify-content: flex-end;
  }
  
  .btn-toggle {
    padding: 0.4rem 0.6rem;
    font-size: 0.875rem;
    min-width: 36px;
    min-height: 36px;
  }
  
  .btn-group-toggle-group {
    gap: 0.25rem;
  }
  
  .btn-toolbar-actions > div {
    flex-shrink: 0;
  }
}

@media (max-width: 576px) {
  .btn-toolbar-actions {
    gap: 0.3rem !important;
  }
  
  .btn-toggle {
    padding: 0.35rem 0.5rem;
    font-size: 0.8rem;
    min-width: 32px;
    min-height: 32px;
  }
}
</style>
